import { CircleExclamationRegularIcon } from "@elixir/icons";
import { HFR_HPR_MIXPANEL_EVENTS } from "@elixir/types";
import React, { useEffect } from "react";
import usePostHprAadharOtp from "../../../apis/axon/hpr/use-post-hpr-aadhaar-otp";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";
import { OnboardingNavigationStates } from "../../../stores/hpr-hfr-dhis-onboarding/enums";
import { track } from "../../../utils/tracking";
import VerifyFlowContainer from "../verify-flow-container";
import AadhaarField from "./aadhaar-field";

const VerifyYourselfWithAadhaar = () => {
  const presetAadhaarNumber = useHprHfrOnboardingStore(
    (state) => state.aadhaarNumber
  );
  const setAadhaarNumberInStore = useHprHfrOnboardingStore(
    (state) => state.setAadhaarNumber
  );
  const [aadharNumber, setAadharNumber] = React.useState(
    () => presetAadhaarNumber || ""
  );
  const [errorMessage, setErrorMessage] = React.useState("");

  const setActiveScreen = useHprHfrOnboardingStore(
    (state) => state.setActiveScreen
  );
  const setTransactionId = useHprHfrOnboardingStore(
    (state) => state.setTransactionId
  );
  const setMaskedMobileNumber = useHprHfrOnboardingStore(
    (state) => state.setMaskedMobileNumber
  );

  useEffect(() => {
    track(HFR_HPR_MIXPANEL_EVENTS.GENERATE_AADHAAR_OTP_PAGE_VIEW);

    if (presetAadhaarNumber && presetAadhaarNumber.length === 12) {
      handleGetOtp({ aadhaar: presetAadhaarNumber });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { mutateAsync: postOtp, isLoading: isPostHprAadhaarLoading } =
    usePostHprAadharOtp();

  const handleGetOtp = async ({ aadhaar }: { aadhaar: string }) => {
    
    setAadhaarNumberInStore(aadhaar);

    const { success, data, error } = await postOtp({ aadharNumber: aadhaar });

    track(HFR_HPR_MIXPANEL_EVENTS.GET_AADHAR_OTP, {
      success: `${success}`,
      error: `${error?.actualMessage || error?.message}`,
    });

    if (success && data) {
      const { txn_id, mobile_num } = data;
      setTransactionId(txn_id);
      setMaskedMobileNumber(mobile_num);
      setActiveScreen(OnboardingNavigationStates.AADHAR_OTP);
    } else {
      setErrorMessage(error?.message || "Please try again");
    }
  };

  return (
    <VerifyFlowContainer
      title="Verify yourself via Aadhar"
      primaryButtonText="Get OTP"
      primaryButtonClick={() => {
        if (aadharNumber.length === 12) {
          handleGetOtp({ aadhaar: aadharNumber });
        } else {
          setErrorMessage("Please enter your full aadhaar number");
        }
      }}
      primaryButtonLoading={isPostHprAadhaarLoading}
    >
      <div className="dr-py-12 dr-space-y-4">
        <div className="BodyBold dr-text-darwin-touch-neutral-1000">
          Enter your Aadhar Number
        </div>
        <AadhaarField
          aadharNumber={aadharNumber}
          setAadharNumber={(aadhaarNum) => {
            if (errorMessage) {
              setErrorMessage("");
            }
            setAadharNumber(aadhaarNum);
          }}
          handleGetOtp={handleGetOtp}
        />
        {errorMessage ? (
          <div className="dr-flex dr-space-x-8 dr-items-center dr-text-darwin-red-primary">
            <CircleExclamationRegularIcon className="dr-w-12 dr-h-12" />
            <div className="CalloutRegular">{errorMessage}</div>
          </div>
        ) : null}
      </div>
    </VerifyFlowContainer>
  );
};

export default VerifyYourselfWithAadhaar;
